import type * as FavCache from '@finn-no/favorite-api-browser-client';
import { useEffect } from 'react';
import { TrackerData } from '@finn-no/pulse-sdk/dist/types';
import { ItemType } from '@finn-no/favorite-api-browser-client';
import pulse from '@finn-no/pulse-sdk';

// Track the start of the flow, as well as the createNewFolder flow
type useStartEventTrackingProps = {
    toggled?: boolean;
    userId?: FavCache.UserId;
    itemType: ItemType;
    itemId: number;
    isOpen: boolean;
};
const useStartEventTracking = ({
    toggled,
    userId,
    itemType,
    itemId,
    isOpen,
}: useStartEventTrackingProps) => {
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        if (userId) {
            const pulsePayload: TrackerData = {
                type: 'Click',
                intent: toggled ? 'Delete' : 'Create',
                name: 'New favorite',
                object: {
                    id:
                        itemType === 'Hotel'
                            ? `classified:hotel:${itemId}`
                            : `classified:${itemId}`,
                    type: 'UIElement',
                    elementType: 'Button',
                    items: [
                        {
                            type: 'ClassifiedAd',
                            id:
                                itemType === 'Hotel'
                                    ? `hotel:${itemId}`
                                    : `${itemId}`,
                            contentId: `${itemId}`,
                            name: 'n/a',
                            category: 'n/a',
                        },
                    ],
                },
                target: {
                    id:
                        itemType === 'Hotel'
                            ? `classified:hotel:${itemId}`
                            : `classified:${itemId}`,
                    type: 'FavoriteItem',
                    name: 'Classified Ad',
                },
            };
            pulse.trackEvent(pulsePayload);
        }
    }, [isOpen]);
};

export default useStartEventTracking;
